/*
  Trava a versão do jQuery que o tema carrega.

  O jQuery existe aqui só por causa do SmartHint (o tema não usa). Algum script
  de terceiro pode tentar sobrescrever window.jQuery por uma versão antiga; este
  guarda aceita a troca apenas se o candidato for um jQuery de verdade, e devolve
  sempre o que o tema carregou.

  Precisa rodar depois do jquery-*.min.js e antes do SmartHint. Por isso é um
  arquivo, e não um <script> inline: os três são defer e scripts com src e defer
  executam na ordem em que aparecem no documento, o que um inline não garante.
*/
(function () {
  var _ecJQuery = window.jQuery;
  if (_ecJQuery && typeof _ecJQuery.ajax === 'function') {
    Object.defineProperty(window, 'jQuery', {
      get: function () { return _ecJQuery; },
      set: function (v) { if (v && typeof v.ajax === 'function') _ecJQuery = v; },
      configurable: true
    });
  }
})();
